export const actionErrRefr = {
  type: 'auth/refreshError',
  payload: null,
};
